import { Box, Typography } from '@atgfr8/atg-ui-tailwind';
import { Button } from '@components';
import { orderUrls } from '@constants/urls';
import { A } from '@solidjs/router';
import { customerStore, orderStore } from '@store/orders';
import { OpenInNewIcon } from '@atgfr8/icons';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { Show } from 'solid-js';

import classes from './classes';

export const CustomerInfoHeader = () => {
  const cls = classes.customerInfo;

  return (
    <Show when={Boolean(orderStore.order.customerId)}>
      <Box class={cls.profileContainer}>
        <Box class="flex items-center">
          <Typography component="h1" variant="h6" class={cls.profileName}>
            {customerStore.customer.name}
          </Typography>
          <A
            href={orderUrls.profile(orderStore.order.customerId as number)}
            target="_blank"
            class={`${
              orderStore.order.customerId === null && 'pointer-events-none'
            } ml-auto`}
          >
            <Button
              variant="contained"
              label="Profile"
              size="sm"
              startIcon={<OpenInNewIcon size={20} />}
              sx={cls.profileStyle}
              disabled={orderStore.order.customerId === null}
              dataTestId={formatDataTestId('Profile', 'button')}
            />
          </A>
        </Box>
        <Box>
          <A
            href={orderUrls.orderSheet(orderStore.order.id)}
            class={`${
              orderStore.order.customerId !== null
                ? cls.anchorLink
                : cls.disabledAnchorLink
            }`}
            target="_blank"
          >
            ORDER SHEET
          </A>
          <A
            href={orderUrls.customerConfirmation(orderStore.order.id)}
            target="_blank"
            class={`${
              orderStore.order.customerId !== null
                ? cls.anchorLink
                : cls.disabledAnchorLink
            }`}
          >
            CUSTOMER CONFIRMATION
          </A>
          <A
            href={orderUrls.invoice(orderStore.order.id)}
            target="_blank"
            class={`${
              orderStore.order.customerId !== null
                ? cls.anchorLink
                : cls.disabledAnchorLink
            }`}
          >
            INVOICE
          </A>
        </Box>
      </Box>
    </Show>
  );
};
